"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const R = react_1.default.createElement;
const Widget_1 = __importDefault(require("./../Widget"));
const ChartWidgetComponent_1 = require("./ChartWidgetComponent");
/** A widget which is a chart */
class ChartWidget extends Widget_1.default {
    chart;
    constructor(chart) {
        super();
        this.chart = chart;
    }
    // Creates a view of the widget.
    // options:
    //  schema: schema to use
    //  dataSource: data source to use
    //  widgetDataSource: Gives data to the widget in a way that allows client-server separation and secure sharing. See definition in WidgetDataSource.
    //  design: widget design
    //  scope: scope of the widget (when the widget self-selects a particular scope)
    //  filters: array of filters to apply. Each is { table: table id, jsonql: jsonql condition with {alias} for tableAlias. Use injectAlias to correct
    //  onScopeChange: called with (scope) as a scope to apply to self and filter to apply to other widgets. See WidgetScoper for details
    //  onDesignChange: called with new design. null/undefined for readonly
    //  width: width in pixels on screen
    //  height: height in pixels on screen
    //  onRowClick: Called with (tableId, rowId) when item is clicked
    createViewElement(options) {
        return R(ChartWidgetComponent_1.ChartWidgetComponent, {
            chart: this.chart,
            design: options.design,
            schema: options.schema,
            widgetDataSource: options.widgetDataSource,
            dataSource: options.dataSource,
            scope: options.scope,
            filters: options.filters,
            onScopeChange: options.onScopeChange,
            onDesignChange: options.onDesignChange,
            width: options.width,
            height: options.height,
            onRowClick: options.onRowClick,
            refreshKey: options.refreshKey,
            locale: options.locale,
            translate: options.translate
        });
    }
    // Get the data that the widget needs. This will be called on the server, typically.
    //   design: design of the chart
    //   schema: schema to use
    //   dataSource: data source to get data from
    //   filters: array of { table: table id, jsonql: jsonql condition with {alias} for tableAlias }
    //   callback: (error, data)
    getData(design, schema, dataSource, filters, callback) {
        // Clean design first
        design = this.chart.cleanDesign(design, schema);
        return this.chart.getData(design, schema, dataSource, filters, callback);
    }
    // Get a list of table ids that can be filtered on
    getFilterableTables(design, schema) {
        // Clean design first
        design = this.chart.cleanDesign(design, schema);
        return this.chart.getFilterableTables(design, schema);
    }
    // Determine if widget is auto-height, which means that a vertical height is not required.
    isAutoHeight() {
        return this.chart.isAutoHeight();
    }
    /** Get a list of translatable strings in the design */
    getTranslatableStrings(design, schema) {
        // Clean design first
        const cleanDesign = this.chart.cleanDesign(design, schema);
        return this.chart.getTranslatableStrings(cleanDesign, schema);
    }
}
exports.default = ChartWidget;
